// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__N0_o7","tooltipContent":"Tooltip_tooltipContent__3VGK7","triangle":"Tooltip_triangle__XiAOE","tooltipHeader":"Tooltip_tooltipHeader__26BqE"};